import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { from, Observable } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  constructor(
    private oidcAuthService: OidcSecurityService,
    private http: HttpClient,
    private router: Router
  ) {}

  handleLoginCallback(): Observable<any> {
    return from(this.oidcAuthService.checkAuthIncludingServer()).pipe(
      tap((result) => {
        console.log('checkAuthIncludingServer result:', result);
      }),
      map((authResult) => {
        if (authResult.isAuthenticated) {
          console.log('User is Authenticated:', authResult.userData);
          return authResult;
        } else {
          console.error('Authentication failed:', authResult);
          throw new Error('Authentication failed');
        }
      }),
      catchError((error) => {
        console.error('Error handling login callback:', error);
        throw error;
      })
    );
  }

  completeCallback(token: string): Observable<any> {
    const url = `${window.location.origin}/api/auth/callback`;
    return this.http.post(url, { token });
  }

  /** The signed-in user's full profile, including roles (`GET /users/me`). */
  getUserProfile(idToken: string): Observable<any> {
    return this.http.get(`${window.location.origin}/api/users/me`, {
      headers: { Authorization: `Bearer ${idToken}` },
    });
  }

  logout(): Observable<any> {
    return this.oidcAuthService.logoff();
  }
}
